<template>
      <div
        class="modal right fade trader-info"
        id="trader-info"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"       
      >
        <div class="modal-dialog modal-dialog-centered modal-md" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">SPREAD</h5>
              
              <button type="button" class="close"  @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
                <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                <table class="table align-items-center table-flush table-hover bidtbl">
                    <thead class="thead-light psticky">
                    <tr>
                        <th scope="col" class="text-center">Date</th>
                        <th scope="col" class="text-center">Spread</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="spread.length == 0 && !loading">
                        <td><p class="nodata">No data available</p>
                        </td>
                    </tr>
                    <tr v-for="(data,index) in spread" :key="index">
                        <td>{{moment(data.date).format("MM/DD/YYYY") }}</td>
                        <td>{{data.spread}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
    </template>

    <script>
    import authService from "@/authService";
    import config from "@/config";

    export default {
        name: 'spreadmodal',
        components :{
            
        },
        props: ['accountData'],
        data() {
            return {
                loading : false,
                spread : []
                
            };
        },
        methods: {   
            getSpread(){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                config.baseUrlBidSide +
                    "/inventory/spread-all?account="+this.accountData.accountNumber,
                    auth
                )
                .then(result => {
                this.spread = result.data;
                this.loading = false;
                })
            },
        },
        mounted(){
            this.getSpread()
        }
    };
    </script>